"use strict";

angular.module("core")
.directive("fileModel", ["$parse", function($parse) {
    return {
        restrict: "A",
        link: function(scope, element, attrs) {
            var isMultiple = attrs.multiple;
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;

            element.bind("change", function() {
                scope.$apply(function() {
                    if (isMultiple) {
                        modelSetter(scope, element[0].files);
                    }
                    else {
                        modelSetter(scope, element[0].files[0]);
                    }
                });
            });
        }
    };
}]);



//////////////////
// WEBPACK FOOTER
// ./core/file-model/file-model.directive.js
// module id = 504
// module chunks = 0